import Image from "next/image"
import React, { useState } from "react"

import { Links } from "config/links"

import useInterval from "components/hooks/use-interval"

import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"
import { TitleDivider } from "components/shared/title-divider"

import img2DBot1 from "/public/images/pages/bot-3d/reborn-section/2d-bot-1.png"
import img2DBot2 from "/public/images/pages/bot-3d/reborn-section/2d-bot-2.png"
import img2DBot3 from "/public/images/pages/bot-3d/reborn-section/2d-bot-3.png"
import img3DBot1 from "/public/images/pages/bot-3d/reborn-section/3d-bot-1.png"
import img3DBot2 from "/public/images/pages/bot-3d/reborn-section/3d-bot-2.png"
import img3DBot3 from "/public/images/pages/bot-3d/reborn-section/3d-bot-3.png"

const sliderData = [
  {
    title: "ZERO",
    image2dSrc: img2DBot1.src,
    image3dSrc: img3DBot1.src,
  },
  {
    title: "DRAGON",
    image2dSrc: img2DBot2.src,
    image3dSrc: img3DBot2.src,
  },
  {
    title: "SAWYER",
    image2dSrc: img2DBot3.src,
    image3dSrc: img3DBot3.src,
  },
]

export function RebornSection() {
  const [currentSlide, setCurrentSlide] = useState(0)

  useInterval(() => {
    setCurrentSlide((currentSlide + 1) % sliderData.length)
  }, 4000)

  return (
    <Box className="bg-[#181142] pl-4 md:pl-8 pt-[2rem] lg:pt-[6rem]">
      <Box className="relative min-h-[45rem] lg:min-h-[50rem] w-full ml-auto">
        <Box className="md:absolute left-0 top-0 md:right-[50%] lg:right-[70%] bottom-0 z-1">
          <Text weight="bold" className={`uppercase lg:text-[5rem] lg:leading-[5rem]`}>
            Cryptobots
          </Text>
          <Text weight="bold" className="uppercase lg:text-[5rem] lg:leading-[5rem]">
            Evolution
          </Text>
          <TitleDivider className="mt-6" />
          <Text className="mt-6" size="h4" weight="bold">
            History
          </Text>
          <Text className="mt-6">
            For almost 5 years we’ve been building the Cryptobots Metaverse — starting with Classic Cryptobots in 2017,
            continued by Cryptobots Companions and Genesis Cryptobots in 2022.
          </Text>
          <Text className="mt-6">
            Now we are ready to make a large step forward in the development of our NFT heritage by introducing the 3D
            Cryptobots!
          </Text>
          <Link className="mt-6 mr-auto w-[14rem]" href={Links.OPENSEA_WRAPP} target="_blank" highlightOnHover={false}>
            <Button size="lg" className="mt-4">
              Buy on OpenSea
            </Button>
          </Link>
          <Box className="mt-[2rem] md:mt-auto">
            <Box className="text-white font-semibold">{sliderData[currentSlide].title}</Box>
            <Box row className="mb-10 mt-4 gap-4">
              {sliderData.map((item, index) => (
                <Box
                  key={index}
                  className={["rounded-md h-3 w-12", index === currentSlide ? "bg-[#4F4ACC]" : "bg-[#2D2271]"].join(
                    " ",
                  )}
                />
              ))}
            </Box>
          </Box>
        </Box>

        <Box className="md:absolute w-full md:w-auto h-[20rem] md:h-auto left-[20%] lg:left-[30%] top-0 right-0 bottom-0">
          <Box full className="slide-item relative w-full">
            <Box center full className="relative">
              <Box full className="relative">
                <Image
                  src={sliderData[currentSlide].image3dSrc}
                  alt="3d-bot"
                  layout="fill"
                  objectFit="contain"
                  objectPosition="bottom right"
                />
              </Box>
              <Box className="absolute left-0 top-0 right-[40%] bottom-0">
                <Box className="absolute left-[5%] md:bottom-[15%] lg:bottom-[25%] w-[10rem] h-[10rem] lg:w-[15rem] lg:h-[15rem]">
                  <Image src={sliderData[currentSlide].image2dSrc} alt="2d-bot" layout="fill" />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
